<div class="breadcrumbs p-3 bg-white d-flex justify-content-between">
  <div>
    <a [routerLink]="'/home/revenue/contract-compliance'">Contract Compliance Summary</a>
    <span class="px-2"> > </span>
    <ng-container>
      <a [routerLink]="'/home/revenue/contract-refunds-help'">Help Center</a>
      <span class="px-2"> > </span>
    </ng-container>
  </div>
  <div>
    <button mat-button class="button-small help-center" (click)="back()">Back</button>
  </div>
</div>
<mat-divider></mat-divider>

<div class="bg-white py-3">
  <div class="container text-center">
    <h2>Refunds Portal Help Center</h2>
  </div>
</div>
<mat-divider></mat-divider>

<div class="flex-grow-1 bg-white">
  <div class="container">
    <div mat-tab-nav-bar class="bg-white">
      <a mat-tab-link
         [routerLink]="'/home/revenue/contract-refunds-help/statuses'"
         routerLinkActive #rlaStatus="routerLinkActive"
         [routerLinkActiveOptions]="{exact:true}"
         [active]="rlaStatus.isActive">
        STATUS GLOSSARY
      </a>
      <a mat-tab-link
         [routerLink]="'/home/revenue/contract-refunds-help/faqs'"
         routerLinkActive #rlaFaqs="routerLinkActive"
         [active]="rlaFaqs.isActive">
        FAQs
      </a>
    </div>
    <div class="flex-grow-1 pt-5">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
